
export default function FounderSection() {
  return (
    <section className="py-16 sm:py-24 md:py-32 bg-[#e8f5e9]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 xl:px-24">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#333333] mb-4 tracking-wide">
              なぜ、Naturiを創業したのか
            </h2>
          </div>

          <div className="bg-white p-4 sm:p-6 md:p-10 lg:p-12 space-y-6">
            <div className="flex justify-center mb-6">
              <div className="w-28 h-28 sm:w-36 sm:h-36 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-[#27ae60]">
                <img
                  src="https://static.readdy.ai/image/80932669f31e28b86429da114025ac51/0c16eb027b89ca666f9551017e2a85aa.png"
                  alt="櫻澤 賢悟"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  width="160"
                  height="160"
                />
              </div>
            </div>

            <div className="space-y-4 sm:space-y-5 text-left">
              <p className="text-[0.85rem] sm:text-base md:text-lg text-[#333333] leading-[1.9]">私がNaturiを立ち上げた理由——</p>

              <p className="text-[0.85rem] sm:text-base md:text-lg text-[#333333] leading-[1.9]">
                多くの企業様のDX推進やEC運用を支援する中で、繰り返し目にしてきた光景があります。
              </p>

              <div className="pl-3 sm:pl-5 border-l-3 border-[#27ae60] space-y-2">
                <p className="text-[0.8rem] sm:text-sm md:text-base text-[#555555] leading-[1.9] italic">
                  「DXを進めたいが、社内に動ける人材がいない」
                </p>
                <p className="text-[0.75rem] sm:text-sm md:text-base text-[#555555] leading-[1.9] italic">
                  「外部に依頼しても、提案だけで終わってしまう」
                </p>
                <p className="text-[0.75rem] sm:text-sm md:text-base text-[#555555] leading-[1.9] italic">
                  「ITツールを導入したが、業務に活かせていない」
                </p>
                <p className="text-[0.8rem] sm:text-sm md:text-base text-[#555555] leading-[1.9] italic">
                  「費用対効果が見えず、投資判断ができない」
                </p>
              </div>

              <p className="text-[0.85rem] sm:text-base md:text-lg text-[#333333] leading-[1.9]">そして何より——</p>

              <p className="text-[0.9rem] sm:text-lg md:text-xl text-[#27ae60] leading-[1.9] text-center py-3">
                「コンサルタントがいないと運用できない」
              </p>

              <p className="text-[0.85rem] sm:text-base md:text-lg text-[#333333] leading-[1.9]">
                この構造的な問題を解決するには「提案だけ」ではなく「実行まで責任を持つ」パートナーが必要だ。
              </p>

              <p className="text-[0.85rem] sm:text-base md:text-lg text-[#333333] leading-[1.9]">
                貴社を「依存させる」のではなく、6カ月後に「もうNaturiがいなくても大丈夫」と言っていただける状態を目指す。
              </p>

              <p className="text-[0.9rem] sm:text-lg md:text-xl text-[#27ae60] leading-[1.9] text-center py-3">
                それが、Naturiの企業理念です。
              </p>

              <p className="text-[0.85rem] sm:text-base md:text-lg text-[#333333] leading-[1.9]">
                外部に依存し続ける関係は、本当の意味でお客様の成長には繋がりません。
              </p>

              <p className="text-[0.85rem] sm:text-base md:text-lg text-[#333333] leading-[1.9]">
                「自分たちの力で、デジタルを使いこなし、売上を作っていける組織」を日本中に増やしたい。
              </p>

              <p className="text-[0.85rem] sm:text-base md:text-lg text-[#333333] leading-[1.9]">
                私達は代行業者ではなく、貴社が最短6カ月で自走できるよう現場に深く入り込み、仕組みを構築する<strong>「経営の右腕」</strong>として伴走します。
              </p>
            </div>

            <div className="pt-6 border-t border-gray-200 text-center space-y-1.5">
              <p className="text-[0.8rem] sm:text-sm md:text-base text-[#333333]">合同会社Naturi 代表社員</p>
              <p className="text-base sm:text-lg md:text-xl text-[#333333]">櫻澤 賢悟</p>
              <p className="text-[0.7rem] sm:text-xs md:text-sm text-[#666666]">デジタル庁「デジタル推進委員」任命</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
